// api.js
import axios from "axios";
import awsconfig from "./config/awsconfig";
import store from "./store";
import { logoutSuccess } from "./store/actions";

const clearSessionStorage = () => {
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.name`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.token`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.userName`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.displayName`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.tokenExpiry`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.refresh_token`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.idToken`
  );
  localStorage.removeItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.user_group`
  );
  localStorage.removeItem(`client_id`);
};

const refreshAccessToken = async (refresh_token) => {
  try {
    const { data } = await axios.post(
      `${awsconfig.REACT_APP_PUBLIC_API}/refresh_token`,
      {
        refresh_token,
        client_id: awsconfig.REACT_APP_REST_CLIENT_ID,
      }
    );
    const { access_token } = data.data;

    localStorage.setItem(
      `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.token`,
      access_token
    );

    return access_token;
  } catch (error) {
    console.error("refresh token error", error);
    clearSessionStorage();
    store.dispatch(logoutSuccess());
  }
};

// Create Axios instance
const api = axios.create({
  baseURL: awsconfig.REACT_APP_PUBLIC_API,
  timeout: 60000,
});

// Request interceptor (inject token dynamically)
api.interceptors.request.use(async (config) => {
  const access_token = localStorage.getItem(
    `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.token`
  );
  config.headers["access_token"] = access_token;
  config.headers["Authorization"] = access_token;
  config.headers["client_id"] = awsconfig.REACT_APP_REST_CLIENT_ID;

  return config;
});

// Response interceptor (handle 401 and retry)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if ([401].includes(error.response?.status) && !error.config._isRetry) {
      error.config._isRetry = true;
      try {
        const refresh_token = localStorage.getItem(
          `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.refresh_token`
        );

        if (!refresh_token) {
          clearSessionStorage();
          store.dispatch(logoutSuccess());
          return Promise.reject(error);
        }

        const newAccessToken = await refreshAccessToken(refresh_token);
        if (newAccessToken) {
          localStorage.setItem(
            `swobbee.portal.${awsconfig.REACT_APP_REST_CLIENT_ID}.token`,
            newAccessToken
          );
          error.config.headers["access_token"] = newAccessToken;
          return api(error.config);
        }
      } catch (err) {
        console.error("error interceptors", err);
        clearSessionStorage();
        store.dispatch(logoutSuccess());
        return Promise.reject(err);
      } finally {
        error.config._isRetry = false;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
